(function() {
    if (customElements.get('base-counter') === undefined) {
        window.CSS.registerProperty({
            name: "--base-counter-value",
            syntax: "<number>",
            initialValue: 0,
            inherits: false,
        })
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        </style>
        <output part="value"></output>
        <slot></slot>
        </div>
        `;
        customElements.define('base-counter', class BaseCounter extends HTMLElement {

            static durations() {
                return {
                    "slow": 4000,
                    "normal": 2000,
                    "fast": 1000,
                    "": 2000,
                }
            }

            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
            }

            get to() {
                return parseFloat(this.getAttribute("to") ?? "0.0");
            }

            get from() {
                return parseFloat(this.getAttribute('from') ?? "0.0");
            }

            get duration() {
                const duration = this.getAttribute('duration') ?? "2s";
                return duration in BaseCounter.durations() ? BaseCounter.durations()[duration] : parseInt(duration);
            }

            get timingFunction() {
                return this.getAttribute('timing-function') ?? "linear";
            }

            connectedCallback() {
                this.reset();
            }

            play(formatter = null) {
                formatter ??= value => parseInt(value);
                const item = this.shadowRoot.querySelector('[part="value"]');
                const animation = item.animate([
                    {"--base-counter-value": this.from},
                    {"--base-counter-value": this.to},
                ], {
                    duration: this.duration,
                    iterations: 1,
                    fill: "forwards",
                    easing: this.timingFunction,
                });
                let update = true;
                // draw update
                const draw = () => {
                    item.innerHTML = formatter(getComputedStyle(item).getPropertyValue("--base-counter-value"));
                    update === true && requestAnimationFrame(draw);
                }
                requestAnimationFrame(draw);
                const done = () => {
                    update = false;
                    this.reset();
                };
                animation.onfinish = done;
                animation.oncancel = done;
            }
            reset() {
                // dont use this.to here - in this case we want to use the raw value...
                this.shadowRoot.querySelector('[part="value"]').innerHTML = this.getAttribute("to");
            }
            attributeChangedCallback(name, oldValue, newValue) {
                if (name === 'to') {
                    this.reset();
                }
            }
        });
    }
})();
